import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import Modal from "components/Modal";

import { useFields, useFormModal } from "./hooks";
import { DynamicField, Form, FormModalHeader } from "./components";

export function FormModal({
  formId,
  fields,
  defaultValues,
  task,
  onClose,
  onDone,
  completeTask,
}) {
  const { formProps, isReady, isSubmitting, submit } = useFormModal(
    formId,
    defaultValues,
    onDone
  );

  const handleSubmit = (data) => {
    submit(data, completeTask);
  };

  return (
    <Modal
      style={{ maxWidth: "500px" }}
      isModalOpen
      data-test="task-form-modal"
      onClose={onClose}
    >
      <FormModalHeader {...task} onClose={onClose} />
      <Modal.Body scrolling>
        <Form id="taskForm" {...formProps} onSubmit={handleSubmit}>
          {fields.map((field) => {
            return (
              <DynamicField
                key={field.id}
                field={field}
                showDefaultValue={!task.isFormFilled}
              />
            );
          })}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          content="Discard Changes"
          type="button"
          onClick={onClose}
          disabled={isSubmitting}
        />
        <Button
          color="green"
          content="Save Changes"
          type="submit"
          form="taskForm"
          loading={isSubmitting}
          disabled={!isReady || isSubmitting}
        />
      </Modal.Footer>
    </Modal>
  );
}

FormModal.propTypes = {
  formId: PropTypes.string.isRequired,
  task: PropTypes.shape({
    taskTitle: PropTypes.string,
    workflowName: PropTypes.string,
    clientName: PropTypes.string,
    formName: PropTypes.string,
    isFormFilled: PropTypes.bool,
  }),
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  fields: PropTypes.array,
  defaultValues: PropTypes.object,
  completeTask: PropTypes.bool,
};

FormModal.defaultProps = {
  fields: [],
  defaultValues: {},
  task: null,
  completeTask: true,
};

function Connector({ formId, ...props }) {
  const { task, fields, loading, defaultValues } = useFields(formId);

  if (loading)
    return <Modal style={{ maxWidth: "500px" }} isModalOpen isLoading />;

  return (
    <FormModal
      formId={formId}
      fields={fields}
      task={task}
      defaultValues={defaultValues}
      {...props}
    />
  );
}

Connector.propTypes = {
  formId: PropTypes.string.isRequired,
};

export default Connector;
